<template>
  <form @submit.prevent="goToTwoStep">
    <div class="loginform">
      <p class="title">{{ $t("components.login") }}</p>
      <div class="form-group">
        <label for="email">{{ $t("components.adres") }}</label>
        <input
          type="email"
          key="email-input"
          v-model="username"
          class="form-control"
          :class="{ 'is-invalid': switchForm && errors.has('email') }"
        />
        <!-- display feedback if input is invalid -->
        <div v-if="switchForm && errors.has('email')" class="invalid-feedback">
          {{ errors.first("email") }}
        </div>
      </div>
      <div class="form-group">
        <label class="password" for="password">{{
          $t("components.wachtwoord")
        }}</label>
        <input
          type="password"
          key="password-input"
          v-model="password"
          class="form-control"
          :class="{ 'is-invalid': switchForm && errors.has('password') }"
        />
        <!-- display feedback if input is invalid -->
        <div
          v-if="switchForm && errors.has('password')"
          class="invalid-feedback"
        >
          {{ errors.first("password") }}
        </div>
      </div>
      <p class="error" v-if="switchForm">{{ errorMessage }}</p>
      <button class="btn" type="submit">
        <div>Verder naar 2-factor authenticatie</div>
        <img src="../../assets/Icons/arrow-white.svg" alt="arrow" />
      </button>
    </div>
    <div class="links">
      <p class="body link" @click="goToForgotPassword">
        {{ $t("components.vergeten") }}
      </p>
      <div class="wrap">
        <p class="body1">{{ $t("components.gegevens") }}</p>
        <p class="body1 link" @click="goToRegister">
          {{ $t("components.aanmelden") }}
        </p>
      </div>
      <p class="body">{{ $t("components.demoversie") }}</p>
    </div>
  </form>
</template>

<script>
// import router from "@/router";

// export default {
//   props: {
//     errorMessage: String,
//     error: {
//       type: Boolean,
//       default: false,
//     },
//   },
//   data() {
//     return {
//       switchForm: false,
//       username: "",
//       password: "",
//     };
//   },
//   methods: {
//     goToForgotPassword() {
//       this.$emit("goToForgotPassword");
//     },
//     goToRegister() {
//       this.$emit("goToRegister");
//     },
//     validationSet() {
//       const rules = {
//         email: {
//           rule: {
//             required: true,
//             email: true,
//           },
//           value: this.username,
//         },
//         password: {
//           rule: {
//             required: true,
//             min: 6,
//           },
//           value: this.password,
//         },
//       };

//       return rules;
//     },
//     goToTwoStep() {
//       this.switchForm = true;
//       if (this.validation(this.validationSet())) {
//         this.$emit("goTo2Factor", {
//           username: this.username,
//           password: this.password,
//         });
//         setTimeout(() => router.push({ query: {} }), 3000);
//       }
//     },
//   },
// };

import { ref, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";

export default {
  props: {
    errorMessage: String,
    error: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const router = useRouter();

    // Define reactive variables using ref
    const switchForm = ref(false);
    const username = ref("");
    const password = ref("");

    // Access Global Validation
    const instance = getCurrentInstance();
    const validation = instance.appContext.config.globalProperties.validation;

    // Define validation rules
    const validationSet = () => {
      const rules = {
        email: {
          rule: {
            required: true,
            email: true,
          },
          value: username.value,
        },
        password: {
          rule: {
            required: true,
            min: 6,
          },
          value: password.value,
        },
      };
      return rules;
    };

    // Define method to navigate to the forgot password page
    const goToForgotPassword = () => {
      emit("goToForgotPassword");
    };

    // Define method to navigate to the register page
    const goToRegister = () => {
      emit("goToRegister");
    };

    // Define method to navigate to the two-step verification page
    const goToTwoStep = () => {
      switchForm.value = true;
      // Assume `validation` is a globally available function, since it's not defined in the code you provided
      if (validation(validationSet())) {
        emit("goTo2Factor", {
          username: username.value,
          password: password.value,
        });
        setTimeout(() => {
          router.push({ query: {} });
        }, 3000);
      }
    };

    // Return the reactive variables and methods
    return {
      switchForm,
      username,
      password,
      goToForgotPassword,
      goToRegister,
      goToTwoStep,
    };
  },
};
</script>

<style lang="sass" scoped>
.close
  display: flex
  justify-content: flex-end
  width: 100%
  padding-left: 18px
  margin-top: -11px
  img
    cursor: pointer
    align-self: center
    margin-left: 30px
    height: 35px
.loginform
  .title
    height: 45px
    color: $black
    font-size: 28px
    font-weight: 300
    padding-bottom: 10px
    margin-top: 0
    text-align: center
  .form-group
    &:focus-within
      color: #104E8A
    .form-control
      width: 100%
      padding-top: 11px
      padding-bottom: 11px
      font-size: 15px
      line-height: 24px
      font-family: Ubuntu
      border: none
      border-bottom: 1px solid $black
      margin-bottom: 2px
      display: inline-flex
      box-sizing: border-box
      &:focus
        outline: none
        color: #104E8A
        border-bottom: 1px solid #104E8A
    .password
      padding-top: 30px
    .is-invalid
      border-bottom: 1px solid $red
    .invalid-feedback
      color: $red
      font-size: 0.8em
    label
      font-size: 15px
      display: flex
  .error
    margin: 0
    margin-top: 10px
    font-size: 15px
    line-height: 26px
    color: $red
  .btn
    height: 45px
    width: 100%
    display: flex
    align-items: center
    font-weight: 500
    font-size: 12px
    margin-top: 25px
    line-height: 18px
    text-align: center
    border-radius: 22.5px
    background-color: $red
    color: $white
    border: none
    transition: background-color 300ms ease
    &:hover
      background-color: #CA3233
    &:focus
      outline: none
    div
      width: 94%
      padding-left: 10px
      margin-right: -25px
.links
  .wrap
    display: flex
    justify-content: center
    height: 20px
    margin-bottom: 10px
    .body1
      text-align: center
      font-size: 15px
      line-height: 20px
      margin: 0
    .link
      text-decoration: none
      color: $black
      font-weight: 500
      margin-left: 5px
      &:hover
        cursor: pointer
  .body
    text-align: center
    font-size: 15px
    line-height: 26px
    margin: 0
    &:first-child
      margin: 0
      margin-top: 10px
      margin-bottom: 30px
  .link
    text-decoration: none
    color: $black
    font-weight: 500
    &:hover
      cursor: pointer
</style>
